export default __webpack_public_path__ + "static/media/ic-new-camera.66bdb20d.svg";